import type { ReactNode } from 'react'
import { dateLabel } from '../lib/format'
import { usePublicDemo } from '../data/PublicDemoContext'
import { useI18n } from '../i18n'

export function WorkspacePageHeader({ eyebrow, title, copy, personality }: { eyebrow: string; title: string; copy: string; personality: string }) {
  const data = usePublicDemo()
  const { copy: i18n, locale } = useI18n()
  return (
    <header className="workspace-page-header">
      <div><span>{eyebrow}</span><h1>{title}</h1><p>{copy}</p></div>
      <div className="module-identity"><span>{personality}</span><b>{i18n.common.asOf} {dateLabel(data.data_as_of, locale)}</b></div>
    </header>
  )
}

export function ModuleTakeaway({ headline, support, stat, statLabel, tone = 'teal' }: { headline: string; support: string; stat: string; statLabel: string; tone?: 'teal' | 'navy' | 'amber' }) {
  const { copy } = useI18n()
  return (
    <section className={`module-takeaway ${tone}`}>
      <div><span>{copy.common.keyTakeaway}</span><h2>{headline}</h2><p>{support}</p></div>
      <div><strong>{stat}</strong><span>{statLabel}</span></div>
    </section>
  )
}

export function WorkspaceSectionHeading({ eyebrow, title, context }: { eyebrow: string; title: string; context?: string }) {
  return <div className="workspace-section-heading"><div><span>{eyebrow}</span><h2>{title}</h2></div>{context && <p>{context}</p>}</div>
}

export function KpiCard({ label, value, context, tone = 'neutral' }: { label: string; value: string; context: string; tone?: 'neutral' | 'favorable' | 'headwind' | 'attention' }) {
  return <article className={`workspace-kpi ${tone}`}><span>{label}</span><strong>{value}</strong><p>{context}</p></article>
}

export function SignalCard({ label, value, fact, icon, tone = 'attention' }: { label: string; value: string; fact: string; icon?: ReactNode; tone?: 'attention' | 'neutral' | 'headwind' }) {
  const { copy } = useI18n()
  return <article className={`module-signal ${tone}`}><div>{icon}<span>{copy.common.areasToReview}</span></div><h3>{label}</h3><strong>{value}</strong><p>{fact}</p></article>
}

export function DataBadge({ children }: { children: ReactNode }) {
  return <span className="data-badge">{children}</span>
}
